import React from 'react';
import { Field } from 'redux-form';
import { FormControl, InputLabel } from '@material-ui/core';
import Select, { createFilter } from 'react-select';

export const Autocomplete = ({ name, placeholder, options, label, onChange, style = {} }) => (
  <FormControl style={style}>
    <InputLabel shrink htmlFor="react-select-single" style={{ width: '150px' }}>
      {label}
    </InputLabel>
    <Field
      name={name}
      component={(props) => (
        <div
          style={{
            top: '16px',
            position: 'relative',
            minWidth: '300px',
            marginBottom: 10,
          }}
        >
          <Select
            inputId={name}
            value={props.input.value}
            onChange={props.input.onChange}
            onBlur={() => props.input.onBlur(props.input.value)}
            filterOption={createFilter({
              matchFrom: 'any',
              stringify: (option) => `${option.label}`,
            })}
            options={options}
            placeholder={placeholder}
            simpleValue
            isClearable
          />
        </div>
      )}
      onChange={onChange}
    />
  </FormControl>
);



// WEBPACK FOOTER //
// ./src/components/forms/Autocomplete.js